import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { IAccountType } from '../../constants/account-types';
import { LoginGuardService } from '../../api/login-guard.service';
import { LangService } from '../../core/lang.service';
import { InstMngView } from '../pnel-my-institution/pnel-my-institution.component';
import { FormGroup, FormControl } from '@angular/forms';
import { MyInstitutionService } from '../my-institution.service';


@Component({
  selector: 'view-mng-inst-info',
  templateUrl: './view-mng-inst-info.component.html',
  styleUrls: ['./view-mng-inst-info.component.scss']
})
export class ViewMngInstInfoComponent implements OnInit {

  public breadcrumb = [];
  isLoading:boolean;
  isLoaded:boolean;

  public addressForm:FormGroup = new FormGroup({
    name: new FormControl(),
    address: new FormControl(),
    postalCode: new FormControl(),
    city: new FormControl(),
    province: new FormControl(),
    phoneNumber: new FormControl(),
    faxNumber: new FormControl(),
    contactEmail: new FormControl(),
  })


  constructor(
    public lang:LangService,
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private myInst:MyInstitutionService,
  ) { 
    this.addressForm.disable();
  }
  
  ngOnInit() {
    this.loginGuard.activate([IAccountType.TEST_ADMIN]);
    window.scrollTo(0,0);
    this.breadcrumb = [
      this.breadcrumbsService.TESTADMIN_LANDING(),
      this.breadcrumbsService.TESTADMIN_DASHBOARD(),
      this.breadcrumbsService._CURRENT(this.lang.tra('ta_title_mng_inst_info'), this.router.url),
    ];
    this.myInst.sub().subscribe(instInfo => {
      if (instInfo && !this.isLoaded){
        this.isLoaded = true;
        this.addressForm.controls.name.setValue(instInfo.name);
        this.addressForm.controls.address.setValue(instInfo.address);
        this.addressForm.controls.postalCode.setValue(instInfo.postalCode);
        this.addressForm.controls.city.setValue(instInfo.city);
        this.addressForm.controls.province.setValue(instInfo.province);
        this.addressForm.controls.phoneNumber.setValue(instInfo.phoneNumber);
        this.addressForm.controls.faxNumber.setValue(instInfo.faxNumber);
        this.addressForm.controls.contactEmail.setValue(instInfo.contactEmail || '');
      }
    })
  }

  editStart(){
    this.addressForm.enable();
  }
  editSave(){
    this.addressForm.disable();
  }
  editCancel(){
    // TO DO : reset form contents
    this.addressForm.disable();
  }

  isInputError(control:FormControl){
    if (control.pristine && ( control.hasError('isBlank') || control.hasError('isInvalid') ) ){
      return true;
    }
  }

  getCurrentInstMngView(){
    return InstMngView.INST_INFO;
  }

}
